import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { find } from 'lodash';
import { selectMenuData } from 'reducers/menu/selectors';
import useLoadByUrl from 'hooks/data/useLoadByUrl';

export const useLoadDefaultContent = () => {
  const menuData = useSelector(selectMenuData);
  const searchTag = find(menuData, ['dashboardTag', 'SEARCH']);

  const { data: searchData, isLoading: isSearchDataLoading } = useLoadByUrl(searchTag.detailsUrl, {
    enabled: !!searchTag.detailsUrl,
  });

  // First one is always recommendations
  const recommendationsUrl = searchData?.[0]?.detailsUrl;

  const { data: recommendationsData, isLoading: isRecommendationsLoading } = useLoadByUrl(recommendationsUrl, {
    enabled: !!recommendationsUrl,
  });

  const isLoading = isSearchDataLoading || isRecommendationsLoading;

  const recommendations = useMemo(() => {
    if (!recommendationsData) return null;

    const { content, title, titles } = recommendationsData;

    return {
      id: 'recommendations',
      content,
      title,
      titles,
    };
  }, [recommendationsData]);

  const defaultGrid = useMemo(() => {
    if (!searchData) return [];
    // First one is always recommendations
    return searchData.slice(1).map(({ carousel }) => ({ ...carousel, type: 'FILTERS_BANNER' }));
  }, [searchData]);

  return { defaultGrid, recommendations, isLoading };
};

export default useLoadDefaultContent;
